/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAuthDto } from '../models/work-auth-dto';
import { WorkGetMailsAndPhonesDto } from '../models/work-get-mails-and-phones-dto';
import { WorkLogoutDto } from '../models/work-logout-dto';
import { WorkMailsAndPhonesDto } from '../models/work-mails-and-phones-dto';
import { WorkProfileDto } from '../models/work-profile-dto';
import { WorkRequestOtpDto } from '../models/work-request-otp-dto';
import { WorkRequestPasswordResetDto } from '../models/work-request-password-reset-dto';
import { WorkResetPasswordDto } from '../models/work-reset-password-dto';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateLanguageDto } from '../models/work-update-language-dto';
import { WorkUpdatePasswordDto } from '../models/work-update-password-dto';
import { WorkVerifyOtpV2Dto } from '../models/work-verify-otp-v-2-dto';

@Injectable({ providedIn: 'root' })
export class WorkAuthenticationV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `authenticationV2ControllerLogin()` */
  static readonly AuthenticationV2ControllerLoginPath = '/v2/auth/loginWithUsernameAndPassword';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationV2ControllerLogin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV2ControllerLogin$Response(
    params: {
      body: WorkAuthDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAuthenticationV2Service.AuthenticationV2ControllerLoginPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authenticationV2ControllerLogin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV2ControllerLogin(
    params: {
      body: WorkAuthDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.authenticationV2ControllerLogin$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `authenticationV2ControllerRefreshToken()` */
  static readonly AuthenticationV2ControllerRefreshTokenPath = '/v2/auth/refreshTokens';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationV2ControllerRefreshToken()` instead.
   *
   * This method doesn't expect any request body.
   */
  authenticationV2ControllerRefreshToken$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAuthenticationV2Service.AuthenticationV2ControllerRefreshTokenPath, 'post');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authenticationV2ControllerRefreshToken$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authenticationV2ControllerRefreshToken(
    params?: {
    },
    context?: HttpContext
  ): Observable<void> {
    return this.authenticationV2ControllerRefreshToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `authenticationV2ControllerLogout()` */
  static readonly AuthenticationV2ControllerLogoutPath = '/v2/auth/logout';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationV2ControllerLogout()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV2ControllerLogout$Response(
    params: {
      body: WorkLogoutDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAuthenticationV2Service.AuthenticationV2ControllerLogoutPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authenticationV2ControllerLogout$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV2ControllerLogout(
    params: {
      body: WorkLogoutDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.authenticationV2ControllerLogout$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `authenticationV2ControllerChangePassword()` */
  static readonly AuthenticationV2ControllerChangePasswordPath = '/v2/auth/changePassword';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationV2ControllerChangePassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV2ControllerChangePassword$Response(
    params: {
      body: WorkUpdatePasswordDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAuthenticationV2Service.AuthenticationV2ControllerChangePasswordPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authenticationV2ControllerChangePassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV2ControllerChangePassword(
    params: {
      body: WorkUpdatePasswordDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.authenticationV2ControllerChangePassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `authenticationV2ControllerChangeLanguage()` */
  static readonly AuthenticationV2ControllerChangeLanguagePath = '/v2/auth/changeLanguage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationV2ControllerChangeLanguage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV2ControllerChangeLanguage$Response(
    params: {
      body: WorkUpdateLanguageDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAuthenticationV2Service.AuthenticationV2ControllerChangeLanguagePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authenticationV2ControllerChangeLanguage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV2ControllerChangeLanguage(
    params: {
      body: WorkUpdateLanguageDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.authenticationV2ControllerChangeLanguage$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `authenticationV2ControllerLogoutFromAllDevices()` */
  static readonly AuthenticationV2ControllerLogoutFromAllDevicesPath = '/v2/auth/logoutFromAllDevices';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationV2ControllerLogoutFromAllDevices()` instead.
   *
   * This method doesn't expect any request body.
   */
  authenticationV2ControllerLogoutFromAllDevices$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAuthenticationV2Service.AuthenticationV2ControllerLogoutFromAllDevicesPath, 'post');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authenticationV2ControllerLogoutFromAllDevices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authenticationV2ControllerLogoutFromAllDevices(
    params?: {
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.authenticationV2ControllerLogoutFromAllDevices$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `authenticationV2ControllerGetMailsAndPhones()` */
  static readonly AuthenticationV2ControllerGetMailsAndPhonesPath = '/v2/auth/getMailsAndPhones';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationV2ControllerGetMailsAndPhones()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV2ControllerGetMailsAndPhones$Response(
    params: {
      body: WorkGetMailsAndPhonesDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMailsAndPhonesDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAuthenticationV2Service.AuthenticationV2ControllerGetMailsAndPhonesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMailsAndPhonesDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authenticationV2ControllerGetMailsAndPhones$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV2ControllerGetMailsAndPhones(
    params: {
      body: WorkGetMailsAndPhonesDto
    },
    context?: HttpContext
  ): Observable<WorkMailsAndPhonesDto> {
    return this.authenticationV2ControllerGetMailsAndPhones$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMailsAndPhonesDto>): WorkMailsAndPhonesDto => r.body)
    );
  }

  /** Path part for operation `authenticationV2ControllerRequestOtp()` */
  static readonly AuthenticationV2ControllerRequestOtpPath = '/v2/auth/requestOtp';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationV2ControllerRequestOtp()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV2ControllerRequestOtp$Response(
    params: {
      body: WorkRequestOtpDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAuthenticationV2Service.AuthenticationV2ControllerRequestOtpPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authenticationV2ControllerRequestOtp$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV2ControllerRequestOtp(
    params: {
      body: WorkRequestOtpDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.authenticationV2ControllerRequestOtp$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `authenticationV2ControllerVerifyOtp()` */
  static readonly AuthenticationV2ControllerVerifyOtpPath = '/v2/auth/verifyOtp';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationV2ControllerVerifyOtp()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV2ControllerVerifyOtp$Response(
    params: {
      body: WorkVerifyOtpV2Dto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAuthenticationV2Service.AuthenticationV2ControllerVerifyOtpPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authenticationV2ControllerVerifyOtp$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV2ControllerVerifyOtp(
    params: {
      body: WorkVerifyOtpV2Dto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.authenticationV2ControllerVerifyOtp$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `authenticationV2ControllerRequestPasswordReset()` */
  static readonly AuthenticationV2ControllerRequestPasswordResetPath = '/v2/auth/requestPasswordReset';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationV2ControllerRequestPasswordReset()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV2ControllerRequestPasswordReset$Response(
    params: {
      body: WorkRequestPasswordResetDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAuthenticationV2Service.AuthenticationV2ControllerRequestPasswordResetPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authenticationV2ControllerRequestPasswordReset$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV2ControllerRequestPasswordReset(
    params: {
      body: WorkRequestPasswordResetDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.authenticationV2ControllerRequestPasswordReset$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `authenticationV2ControllerResetPassword()` */
  static readonly AuthenticationV2ControllerResetPasswordPath = '/v2/auth/resetPassword';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationV2ControllerResetPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV2ControllerResetPassword$Response(
    params: {
      body: WorkResetPasswordDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAuthenticationV2Service.AuthenticationV2ControllerResetPasswordPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authenticationV2ControllerResetPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationV2ControllerResetPassword(
    params: {
      body: WorkResetPasswordDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.authenticationV2ControllerResetPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `authenticationV2ControllerProfile()` */
  static readonly AuthenticationV2ControllerProfilePath = '/v2/auth/profile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationV2ControllerProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  authenticationV2ControllerProfile$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProfileDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAuthenticationV2Service.AuthenticationV2ControllerProfilePath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProfileDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authenticationV2ControllerProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authenticationV2ControllerProfile(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkProfileDto> {
    return this.authenticationV2ControllerProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProfileDto>): WorkProfileDto => r.body)
    );
  }

}
